import { render, staticRenderFns } from "./PorPeriodoModal.vue?vue&type=template&id=54e87b86&scoped=true"
import script from "./PorPeriodoModal.vue?vue&type=script&lang=js"
export * from "./PorPeriodoModal.vue?vue&type=script&lang=js"
import style0 from "./PorPeriodoModal.vue?vue&type=style&index=0&id=54e87b86&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54e87b86",
  null
  
)

export default component.exports